import {IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';

/**
 * Represents ViewPromotionEvent
 */
export default class ViewPromotionEvent implements IAnalyticsEvent {
	public event: string;
	public event_trigger: string;
	public ecommerce: any;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		this.event = EAnalyticsEventType.VIEW_PROMOTION;
		this.event_trigger = 'ecomm';
		this.ecommerce = {
			promotion_id: data.id,
			promotion_name: data.name,
			creative_name: data.creative,
			creative_slot: data.position,
		};
	}
}
